const map = document.getElementById('map');
const exists = typeof(map) != 'undefined' && map != null;

document.addEventListener('DOMContentLoaded', () => {
    if (exists) {
        const divisionsMap = new Map();
        divisionsMap.init();
    };
});

class Map {
    constructor() {
        this.mapBranches = document.querySelectorAll('.js-map-branch');
        this.mainTextEl = document.querySelector('.js-map-text');
        this.cardEl = document.querySelector('.js-map-branch-card');
        this.closeBtn = document.querySelector('.js-map-branch-card-close');
        this.mapInner = document.querySelector('.js-map-inner');
        this.mapWrapper = document.querySelector('.js-map-wrapper');

        this.firstArrow = document.querySelector('.js-map-arrow-one');
        this.secondArrow = document.querySelector('.js-map-arrow-two');
        this.thirdArrow = document.querySelector('.js-map-arrow-three');
        this.fourthArrow = document.querySelector('.js-map-arrow-four');

        this.handleBranchClick = this.handleBranchClick.bind(this);
        this.handleBranchMouseover = this.handleBranchMouseover.bind(this);
        this.handleBranchMouseout = this.handleBranchMouseout.bind(this);
        this.handleRevertInitialState = this.handleRevertInitialState.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.elZoomed = null;
        this.branchPositions = [];
    }

    init() {
        // Get size of map
        const mapSizes = {
            width: this.mapWrapper.getBoundingClientRect().width,
            height: this.mapWrapper.getBoundingClientRect().height,
        };

        // Create array of branches and values map should be repositioned according to on click
        [...this.mapBranches].forEach(el => {
            this.branchPositions.push({
                el,
                elX: (mapSizes.width / 2 - el.offsetLeft) / mapSizes.width * 100,
                elY: (mapSizes.height / 2 - el.offsetTop) / mapSizes.height * 100,
            })
        });

        const mql = window.matchMedia('(min-width: 1281px)');

        // Init methods
        this.initTooltips();
        this.revertInitialState();
        this.handleMapTransitionEnd();

        // Call methods accorging to MQ
        const checkMQ = (matches) => {
            if (!matches) {
                this.triggerTooltips('disable')
                this.removeListeners();

                this.mapWrapper.classList.remove('active');
                this.mapInner.style.transform = null;
            } else {
                this.triggerTooltips('enable')
                this.addListeners();
                
                if (this.elZoomed) {
                    this.mapWrapper.classList.add('active');
                    this.mapInner.style.transform = this.elZoomed.style;
                }
            }
        }

        checkMQ(mql.matches);

        mql.addListener(e => {
            checkMQ(e.matches);
        });
    }

    initTooltips() {
        $(".js-map-arrow:not([data-tooltipster-side='right'])").tooltipster({
            theme: 'tooltipster__map-customized',
        });

        $(".js-map-arrow[data-tooltipster-side='right']").tooltipster({
            theme: 'tooltipster__map-customized',
            side: 'right',
            maxWidth: '150',
        });
    }

    triggerTooltips(method) {
        $(".js-map-arrow:not([data-tooltipster-side='right'])").tooltipster(method);
        $(".js-map-arrow[data-tooltipster-side='right']").tooltipster(method);
    }

    /**
     * Scale and translate map inner
     * @param {HTMLElement} element Bases on position of this elem card should be centered
     */
    zoomMap(element) {
        this.mapWrapper.classList.add('active');

        this.branchPositions.forEach(pos => {
            if (pos.el === element) {
                const style = `scale(1.5) translate(${pos.elX}%, ${pos.elY}%)`;
                this.mapInner.style.transform = style;

                this.elZoomed = {
                    element,
                    style
                };
            }
        });
    }

    /**
     * Get all stuff done with branch click. See comments inside method.
     * @param {object} e Event object
     */
    handleBranchClick(e) {
        e.preventDefault();
        const branch = e.currentTarget;

        // Get data
        const data = branch.dataset;
        const title = branch.querySelector('.js-branch-caption-title span').textContent;
        const imgEl = this.cardEl.querySelector('.js-map-branch-card-img');
        const titleEl = this.cardEl.querySelector('.js-map-branch-card-title');
        const addressEl = this.cardEl.querySelector('.js-map-branch-card-address');
        const textEl = this.cardEl.querySelector('.js-map-branch-card-text');
        const linkEl = this.cardEl.querySelector('.js-map-branch-card-link');

        // Incert data
        titleEl.textContent = title;
        imgEl.setAttribute('src', data.img);
        linkEl.setAttribute('href', data.link);
        addressEl.textContent = data.address;
        textEl.textContent = data.text;

        // Hide text and show branch card
        this.mainTextEl.classList.add('hidden');
        this.cardEl.classList.add('visible');

        document.addEventListener('click', this.handleClickOutside);

        // Disable tooltips so they don't need to reposition
        this.triggerTooltips('disable')

        this.zoomMap(branch)
    }

    handleClickOutside(e) {
        let isClickInside = this.cardEl.contains(event.target);

        [...this.mapBranches].forEach(el => {
            if (el.contains(event.target)) isClickInside = true;
        })

        if (!isClickInside) this.handleRevertInitialState();
    }

    /**
     * Enable tooltips againg after map has transitioned
     */
    handleMapTransitionEnd() {
        this.mapInner.addEventListener('transitionend', (e) => {
            this.triggerTooltips('enable')
        });
    }

    /**
     * Highlight arrows and activate tooltips
     * @param {object} e Event object
     */
    handleBranchMouseover(e) {
        // console.log(e.currentTarget)
        this.selectArrows(e.currentTarget, 'add')
    }

    /**
     * Unhighlight arrows and deactivate tooltips
     * @param {object} e Event object
     */
    handleBranchMouseout(e) {
        this.selectArrows(e.currentTarget, 'remove')
    }

    /**
     * Revert map and card to initial state
     */
    handleRevertInitialState() {
        this.mainTextEl.classList.remove('hidden');
        this.cardEl.classList.remove('visible');
        this.mapWrapper.classList.remove('active');
        this.mapInner.style.transform = '';
        this.elZoomed = null;
        document.addEventListener('click', this.handleClickOutside);
    }

    /**
     * Highlight or unhighlight arrows
     * @param {string} action Add or remove highlight
     * @param  {...any} els Array of dom nodes
     */
    highlightArrows(action, ...els) {
        [...els].forEach(e => (e.classList[action]('active')));
    }

    /**
     * Check which highlight action to apply to which arrows
     * @param {HTMLElement} el Dom node
     * @param {string} action Add or remove
     */
    selectArrows(el, action) {
        const tooltipAction = action === 'add' ? 'open' : 'close';

        if (el.classList.contains('js-map-branch-one')) {
            this.highlightArrows(action, this.secondArrow, this.fourthArrow)
            $([this.secondArrow, this.fourthArrow]).tooltipster(tooltipAction);
        } else if (el.classList.contains('js-map-branch-two')) {
            this.highlightArrows(action, this.fourthArrow, this.thirdArrow)
            $([this.fourthArrow, this.thirdArrow]).tooltipster(tooltipAction);
        } else if (el.classList.contains('js-map-branch-three')) {
            this.highlightArrows(action, this.secondArrow, this.thirdArrow, this.firstArrow)
            $([this.secondArrow, this.thirdArrow, this.firstArrow]).tooltipster(tooltipAction)
        } else {
            this.highlightArrows(action, this.firstArrow)
            $(this.firstArrow).tooltipster(tooltipAction)
        }
    }

    addListeners() {
        [...this.mapBranches].forEach(el => el.addEventListener('click', this.handleBranchClick));
        [...this.mapBranches].forEach(el => el.addEventListener('mouseover', this.handleBranchMouseover));
        [...this.mapBranches].forEach(el => el.addEventListener('mouseout', this.handleBranchMouseout));
    }

    removeListeners() {
        [...this.mapBranches].forEach(el => el.removeEventListener('click', this.handleBranchClick));
        [...this.mapBranches].forEach(el => el.removeEventListener('mouseover', this.handleBranchMouseover));
        [...this.mapBranches].forEach(el => el.removeEventListener('mouseout', this.handleBranchMouseout));
    }

    revertInitialState() {
        this.closeBtn.addEventListener('click', this.handleRevertInitialState);
    }
}



// WEBPACK FOOTER //
// ./frontend/components/map/map.js